import { Link } from 'react-router-dom';
import YappyliLogo from './YappyliLogo';

const PAGES = [
  { to: '/about', label: 'About' },
  { to: '/download', label: 'Download' },
  { to: '/business', label: 'Business' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
  { to: '/contact', label: 'Contact' },
];

// Links with an empty href are hidden. Fill in Twitter/X and Instagram when the accounts exist.
const SOCIAL = [
  { href: 'https://www.facebook.com/yappyliapp', icon: 'fa-brands fa-facebook', label: 'Facebook' },
  { href: 'https://www.tiktok.com/@yappyliapp', icon: 'fa-brands fa-tiktok', label: 'TikTok' },
  { href: 'https://www.youtube.com/@yappyli', icon: 'fa-brands fa-youtube', label: 'YouTube' },
  { href: '', icon: 'fa-brands fa-twitter', label: 'Twitter' },
  { href: '', icon: 'fa-brands fa-instagram', label: 'Instagram' },
];

export default function Footer() {
  return (
    <footer className="yp site-footer">
      <div className="container footer-container">
        <Link to="/" className="logo" style={{ fontSize: '1.2rem' }}>
          <YappyliLogo small />
        </Link>
        <nav className="footer-links">
          {PAGES.map((p) => (
            <Link key={p.to} to={p.to}>{p.label}</Link>
          ))}
        </nav>
        <p>&copy; {new Date().getFullYear()} Yappyli. Chat Happily. All rights reserved.</p>
        <div className="footer-social">
          {SOCIAL.filter((s) => s.href).map((s) => (
            <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
              <i className={s.icon}></i>
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}